module.exports = __webpack_public_path__ + "static/media/menuOptionMessage.aac5ae8b.svg";